import React from "react";
import "../styles/ActionButton.css";
import { ArrowUpRight } from "lucide-react";
import ScrambleText from "./ScrambleText";
import { Link } from "react-router-dom";


export const ActionButton1 = (props) => {
  console.log(props);
  const label = props?.data;
  const showIcon = props?.showIcon !== false;
  return (
    <div className="button-outer">
      <span className="corner top-left" />
      <span className="corner top-right" />
      <span className="corner bottom-left" />
      <span className="corner bottom-right" />
      <button className="action-button">
        <span className="text">
          <ScrambleText text={label} />
        </span>
        {showIcon && <ArrowUpRight className="icon" size={16} strokeWidth={2} />}
      </button>
    </div>
  );
};
export default ActionButton1;
